import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import LayoutUnauthenticated from '@/views/layouts/Unauthenticated'
import LayoutAuthenticated from '@/views/layouts/Authenticated'
import LayoutAuthenticatedDeveloper from '@/views/layouts/AuthenticatedDeveloper'

import AppGlobalError from '@/components/app/GlobalError'
import Alert from '@/components/app/Alert'
import AlertDialog from '@/components/app/AlertDialog'

Vue.component('app-layout-unauthenticated', LayoutUnauthenticated)
Vue.component('app-layout-authenticated', LayoutAuthenticated)
Vue.component('app-layout-authenticated-developer', LayoutAuthenticatedDeveloper)

Vue.component('app-global-error', AppGlobalError)
Vue.component('app-alert', Alert)
Vue.component('app-alert-dialog', AlertDialog)

Vue.config.productionTip = false

function findGetParameter (parameterName) {
  var result = null
  var tmp = []
  location.search.substr(1).split('&')
    .forEach(function (item) {
      tmp = item.split('=')
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
    })
  return result
}

const token = findGetParameter('token') || process.env.VUE_APP_API_TOKEN
const env = findGetParameter('env') || 'dev'
const fv = findGetParameter('fv') || 1
window.localStorage.setItem('token', token)
window.localStorage.setItem('env', env)
window.localStorage.setItem('fv', fv)

// this is null if we are viewing the app directly in the browser during development
if (findGetParameter('fv') == null) {
  window.localStorage.setItem('inBrowser', true)
} else {
  window.localStorage.setItem('inBrowser', false)
}

console.log('Starting App:')
console.log(`\tToken: ${token}`)
console.log(`\tEnv: ${env}`)
console.log(`\tFV: ${fv}`)
console.log(`\tAPI URL: ${process.env.VUE_APP_HOST}`)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created () {
    console.log('main.js created')
    // auto signin user that already has credentials stored in cookies
    var jwt = window.localStorage.getItem('jwt')
    var role = window.localStorage.getItem('role')
    if (jwt !== null && jwt !== 'undefined' && jwt !== '') {
      this.$store.dispatch('auth/autoSignIn', { token: jwt, role: role })
      this.$store.dispatch('auth/loadUserData')
    }
  }
}).$mount('#app')
